// Translations for the site's own fixed UI text (navigation labels,
// common buttons) -- separate from the content translation system in
// LanguageContext.js, which handles admin-entered Research/Article/
// etc. text. This is a small, hand-maintained dictionary rather than
// a full i18n library, since the set of strings that actually need
// translating here is modest and known in advance.
//
// Add a new key here, in all 5 languages, whenever a new piece of
// fixed UI text needs to support translation. Every key MUST have an
// 'en' entry -- it's the guaranteed fallback if a translation is
// ever missing for another language.
const UI_STRINGS = {
  'nav.home': { en: 'Home', fr: 'Accueil', pt: 'Início', es: 'Inicio', zh: '首页' },
  'nav.publications': { en: 'Publications', fr: 'Publications', pt: 'Publicações', es: 'Publicaciones', zh: '出版物' },
  'nav.research': { en: 'Research Papers', fr: 'Documents de recherche', pt: 'Trabalhos de Pesquisa', es: 'Trabajos de Investigación', zh: '研究论文' },
  'nav.ghanaianArticles': { en: 'Ghanaian Articles', fr: 'Articles Ghanéens', pt: 'Artigos Ganeses', es: 'Artículos Ghaneses', zh: '加纳文章' },
  'nav.currentAffairs': { en: 'Current Affairs', fr: 'Actualités', pt: 'Atualidades', es: 'Actualidad', zh: '时事' },
  'nav.explore': { en: 'Explore', fr: 'Explorer', pt: 'Explorar', es: 'Explorar', zh: '探索' },
  'nav.exploreDatasets': { en: 'Explore Datasets', fr: 'Explorer les données', pt: 'Explorar Dados', es: 'Explorar Datos', zh: '浏览数据集' },
  'nav.downloadData': { en: 'Download Data', fr: 'Télécharger les données', pt: 'Baixar Dados', es: 'Descargar Datos', zh: '下载数据' },
  'nav.openBook': { en: 'Podcast', fr: 'Podcast', pt: 'Podcast', es: 'Podcast', zh: '播客' },
  'nav.about': { en: 'About', fr: 'À Propos', pt: 'Sobre', es: 'Acerca de', zh: '关于' },
  'nav.companyProfile': { en: 'Company Profile', fr: 'Profil de l\'Entreprise', pt: 'Perfil da Empresa', es: 'Perfil de la Empresa', zh: '公司简介' },
  'nav.donate': { en: 'Donate', fr: 'Faire un Don', pt: 'Doar', es: 'Donar', zh: '捐赠' },
  'nav.login': { en: 'Login', fr: 'Connexion', pt: 'Entrar', es: 'Iniciar Sesión', zh: '登录' },
  'nav.register': { en: 'Register', fr: 'S\'inscrire', pt: 'Registar', es: 'Registrarse', zh: '注册' },
  'nav.logout': { en: 'Logout', fr: 'Déconnexion', pt: 'Sair', es: 'Cerrar Sesión', zh: '登出' },
  'nav.profile': { en: 'Profile', fr: 'Profil', pt: 'Perfil', es: 'Perfil', zh: '个人资料' },
  'nav.dashboard': { en: 'Dashboard', fr: 'Tableau de Bord', pt: 'Painel', es: 'Panel', zh: '仪表板' },
  'nav.favorites': { en: 'Favorites', fr: 'Favoris', pt: 'Favoritos', es: 'Favoritos', zh: '收藏' },
  'nav.viewAll': { en: 'View all', fr: 'Voir tout', pt: 'Ver tudo', es: 'Ver todo', zh: '查看全部' },

  'button.readMore': { en: 'Read more', fr: 'Lire plus', pt: 'Leia mais', es: 'Leer más', zh: '阅读更多' },
  'button.download': { en: 'Download', fr: 'Télécharger', pt: 'Baixar', es: 'Descargar', zh: '下载' },
  'button.viewDetails': { en: 'View Details', fr: 'Voir les Détails', pt: 'Ver Detalhes', es: 'Ver Detalles', zh: '查看详情' },
  'button.search': { en: 'Search', fr: 'Rechercher', pt: 'Pesquisar', es: 'Buscar', zh: '搜索' },
  'footer.newsletterPrompt': {
    en: 'Get new research and episodes by email:',
    fr: 'Recevez les nouvelles recherches et épisodes par e-mail :',
    pt: 'Receba novas pesquisas e episódios por e-mail:',
    es: 'Recibe nuevas investigaciones y episodios por correo electrónico:',
    zh: '通过电子邮件获取新研究和节目：',
  },
  'footer.allRightsReserved': {
    en: 'All rights reserved.',
    fr: 'Tous droits réservés.',
    pt: 'Todos os direitos reservados.',
    es: 'Todos los derechos reservados.',
    zh: '版权所有。',
  },
  'footer.aboutAcar': {
    en: 'About ACAR',
    fr: 'À Propos de l\'ACAR',
    pt: 'Sobre a ACAR',
    es: 'Acerca de ACAR',
    zh: '关于 ACAR',
  },
};

// Returns the translated UI string for `key` in `language`, falling
// back to the English version if that language's translation is
// missing, and to the key itself (visibly obvious placeholder,
// easier to spot and fix than a blank string) if even English is
// somehow missing.
export const getUIText = (key, language) => {
  const entry = UI_STRINGS[key];
  if (!entry) return key;
  return entry[language] || entry.en || key;
};

export default UI_STRINGS;
